export default __webpack_public_path__ + "static/media/2.f61bd02a.jpeg";